import Navatar$f from './locales/ar-SA/translation.json.js';
import Navatar$e from './locales/de-DE/translation.json.js';
import Navatar$d from './locales/en-US/translation.json.js';
import Navatar$c from './locales/es-ES/translation.json.js';
import Navatar$b from './locales/fr-CA/translation.json.js';
import Navatar$a from './locales/id-ID/translation.json.js';
import Navatar$9 from './locales/it-IT/translation.json.js';
import Navatar$8 from './locales/ja-JP/translation.json.js';
import Navatar$7 from './locales/ko-KR/translation.json.js';
import Navatar$6 from './locales/pt-BR/translation.json.js';
import Navatar$5 from './locales/ru-RU/translation.json.js';
import Navatar$4 from './locales/th-TH/translation.json.js';
import Navatar$3 from './locales/tr-TR/translation.json.js';
import Navatar$2 from './locales/vi-VN/translation.json.js';
import Navatar$1 from './locales/zh-CN/translation.json.js';
import Navatar from './locales/zh-TW/translation.json.js';

const translations = {
    "ar-SA": Navatar$f,
    "de-DE": Navatar$e,
    "en-US": Navatar$d,
    "es-ES": Navatar$c,
    "fr-CA": Navatar$b,
    "id-ID": Navatar$a,
    "it-IT": Navatar$9,
    "ja-JP": Navatar$8,
    "ko-KR": Navatar$7,
    "pt-BR": Navatar$6,
    "ru-RU": Navatar$5,
    "th-TH": Navatar$4,
    "tr-TR": Navatar$3,
    "vi-VN": Navatar$2,
    "zh-CN": Navatar$1,
    "zh-TW": Navatar,
};

export { translations };
